"use strict";
exports.__esModule = true;
exports["default"] = window.MTBlockEditor.Block;
